<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'
import ArrowIcon from '@/components/shared/ArrowIcon.vue'
import MarketingHeroArt from '@/components/marketing/MarketingHeroArt.vue'
import { HERO_IMAGES } from '@/assets/marketing/heroes/images'

const { t } = useI18n()
</script>

<template>
  <section class="relative min-h-screen bg-slate-900 flex items-center justify-center overflow-hidden">
    <MarketingHeroArt v-bind="HERO_IMAGES.home" />
    <div
      class="absolute inset-0 pointer-events-none"
      style="background: radial-gradient(ellipse 80% 60% at 50% 40%, rgba(16,185,129,0.10) 0%, transparent 70%);"
    ></div>

    <div class="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">
      <div class="inline-flex items-center bg-emerald-500/10 text-emerald-400 text-sm font-medium px-4 py-1.5 rounded-full mb-8">
        🏁 {{ t('home.hero.badge') }}
      </div>

      <h1 class="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight">
        {{ t('home.hero.headline') }}
      </h1>

      <p class="text-lg md:text-xl text-slate-400 mt-6 max-w-2xl mx-auto leading-relaxed">
        {{ t('home.hero.subheadline') }}
      </p>

      <div class="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
        <RouterLink
          :to="{ name: 'public.for-organizers' }"
          class="inline-flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white font-semibold rounded-lg px-8 py-4 text-base transition-colors"
        >
          {{ t('home.hero.cta_organizer') }}
          <ArrowIcon direction="right" class="w-4 h-4" />
        </RouterLink>
        <RouterLink
          :to="{ name: 'public.for-participants' }"
          class="inline-flex items-center justify-center gap-2 bg-sky-600 hover:bg-sky-500 text-white font-semibold rounded-lg px-8 py-4 text-base transition-colors"
        >
          {{ t('home.hero.cta_participant') }}
          <ArrowIcon direction="right" class="w-4 h-4" />
        </RouterLink>
      </div>

      <div class="mt-16 flex justify-center">
        <ArrowIcon direction="down" class="w-6 h-6 text-slate-600 animate-bounce" />
      </div>
    </div>
  </section>
</template>
